/**
 * Constants for the Public Websearch Chatbot Client
 */

/**
 * Default fallback color for chatbot UI elements when configuration is not available
 */
export const DEFAULT_CHATBOT_COLOR = 'rgba(0, 0, 0, 1)';

/**
 * Default fallback color for text/icons displayed over the theme background
 */
export const DEFAULT_COLOR_OVER_THEME = 'rgba(255, 255, 255, 1)';

/**
 * Other chatbot-related constants
 */
export const CHATBOT_CONSTANTS = {
  /** Default color for all chatbot UI elements */
  DEFAULT_COLOR: DEFAULT_CHATBOT_COLOR,

  /** Default configuration values */
  DEFAULT_NAME: 'Assistant',
  DEFAULT_BUBBLE_TEXT: 'Hi! How can I help you?',
  DEFAULT_WELCOME_TEXT: 'Welcome! How can I assist you today?',

  /** Session management constants */
  MAX_RESTORE_ATTEMPTS: 5,
  BASE_RESTORE_DELAY_MS: 50,
  AUTO_SAVE_INTERVAL_MS: 30000,
  SESSION_TIMEOUT_CHECK_INTERVAL_MS: 30000,

  /** Input validation constants */
  MAX_INPUT_LENGTH: 500,

  /** Responsive breakpoints (aligned with Tailwind defaults) */
  BREAKPOINTS: {
    /** Small screen breakpoint - min-width: 640px (Tailwind sm:) */
    SM: 640,
    /** Medium screen breakpoint - min-width: 768px (Tailwind md:) */
    MD: 768,
    /** Large screen breakpoint - min-width: 1024px (Tailwind lg:) */
    LG: 1024,
  },
} as const;
